import { ChangeEvent } from "react";

const phoneFormater = (input: HTMLInputElement) => {
  let value = input.value.replace(/\D/g, "");

  if (value.startsWith("55") && value.length > 11) {
    value = value.slice(2);
  }

  value = value.slice(0, 11);

  if (value.length > 0) {
    const ddd = value.slice(0, 2);
    let rest = value.slice(2);

    if (rest.length > 5) {
      input.value = `(${ddd}) ${rest.slice(0, 5)}-${rest.slice(5)}`;
    } else if (rest.length > 0) {
      input.value = `(${ddd}) ${rest}`;
    } else {
      input.value = `(${ddd}`;
    }
  } else {
    input.value = "";
  }
};

export const phoneMask = (event: ChangeEvent<HTMLInputElement>) => {
  if (event.target instanceof HTMLInputElement) {
    phoneFormater(event.target);
  }
};
